import { format } from 'date-fns'

const to_date = (unix: number) => format(new Date(unix * 1000), 'PP')

export const formatDate = (dateStr: string, dateFormat: string = 'PP') => {
  const date = new Date(dateStr)
  return format(date, dateFormat)
}

export { to_date }
